<template>
  <div v-if="missing.length" class="ov-reporting-hint" :class="{ 'ov-reporting-hint--partial': !allMissing }">
    <i class="material-icons">{{ allMissing ? 'insights' : 'info_outline' }}</i>
    <div class="ov-reporting-hint-text">
      <strong v-if="allMissing">{{ $t('dash.overview.reporting_hint.title') }}</strong>
      <p v-if="allMissing">{{ $t('dash.overview.reporting_hint.empty') }}</p>
      <p v-else>
        {{ $t('dash.overview.reporting_hint.partial', { count: missing.length, total: eligible.length }) }}
        <Tooltip :text="missingNames" position="top"><span class="ov-reporting-hint-names">{{ shortNames }}</span></Tooltip>
      </p>
    </div>
    <button class="ov-action ov-action--primary ov-reporting-hint-btn" @click="$emit('open', missing.map(p => p.id))">
      <i class="material-icons">insert_chart</i><span>{{ $t('dash.overview.reporting_hint.cta') }}</span>
    </button>
  </div>
</template>

<script>
import Tooltip from '../tooltip/tooltipInit.vue'

/**
 * Statistiques d'audience absentes : elles viennent du Reporting (récupérées à l'ouverture de la section), l'overview ne fait que les lire
 */
export default {
  name: 'OverviewReportingHint',

  components: { Tooltip },

  props: {
    // per_page de /reporting/overview : reporting (éligible) et has_data (stats sur la période)
    perPage: { type: Array, default: null },
    pages: { type: Array, default: () => [] }
  },

  computed: {
    eligible() {
      return (this.perPage || []).filter(p => p.reporting)
    },

    missing() {
      return this.eligible.filter(p => !p.has_data).map(p => ({ id: String(p.id), name: this.pageName(p.id) }))
    },

    allMissing() {
      return this.missing.length === this.eligible.length
    },

    missingNames() {
      return this.missing.map(p => p.name).join(', ')
    },

    shortNames() {
      const names = this.missing.slice(0, 3).map(p => p.name).join(', ')
      return this.missing.length > 3 ? `${names}…` : names
    }
  },

  methods: {
    pageName(id) {
      const page = this.pages.find(p => String(p.id) === String(id))
      return (page && page.name) || String(id)
    }
  }
}
</script>

<style scoped>
.ov-reporting-hint {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  border: 1px solid #e0d0ea;
  border-radius: 14px;
  background: #faf6fc;
}
.ov-reporting-hint > .material-icons {
  flex: 0 0 auto;
  font-size: 26px;
  color: #b64985;
}
.ov-reporting-hint--partial {
  padding: 10px 14px;
  background: #fff;
}
.ov-reporting-hint--partial > .material-icons {
  font-size: 20px;
}
.ov-reporting-hint-text {
  flex: 1;
  min-width: 0;
}
.ov-reporting-hint-text strong {
  display: block;
  margin-bottom: 2px;
  font-size: 14px;
  color: #121826;
}
.ov-reporting-hint-text p {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.45;
  color: #555e75;
}
.ov-reporting-hint-names {
  font-weight: 600;
  color: #121826;
}
.ov-reporting-hint-btn {
  flex: 0 0 auto;
}
@media (max-width: 700px) {
  .ov-reporting-hint {
    flex-wrap: wrap;
  }
}
</style>
